// REFACTORED: 2026-02-02
// FROM src/components/layout/DashboardLayout.tsx

// ============================================================================
// ADMIN ACCESS & AUTHORIZATION
// ============================================================================

/**
 * Check if user has admin access (admin/super_admin roles only)
 */
export const hasAdminAccess = (user: { role?: { name?: string } } | null): boolean => {
  return !!(user && (user.role?.name === 'admin' || user.role?.name === 'super_admin'));
};